'use client';

import { useState } from 'react';

interface Testimonial {
  id: number;
  name: string;
  relationship: string;
  achievement: string;
  quote: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Parul',
    relationship: 'Mother of a State Champion',
    achievement: 'State Champion',
    quote: 'Go Speed Academy is truly the best place for children to engage in sports and achieve great success at school, state, and even national levels. My child is living proof of this as a proud state champion!',
  },
  {
    id: 2,
    name: 'Amrita Khosla',
    relationship: 'Parent',
    achievement: 'National Medal - SGFI 100m',
    quote: 'Under the expert guidance of the coaches at Go Speed, my daughter won a national medal in SGFI 100m. This academy is a must for parents who want nothing but the best for their children.',
  },
  {
    id: 3,
    name: 'Mala Singh',
    relationship: 'Parent',
    achievement: 'Two-Time Delhi State Champion & School Sports Captain',
    quote: 'Watching my daughter grow from a 7-year-old into a two-time Delhi state champion and the sports captain of her school has been an incredible journey. I\'m deeply grateful to Go Speed for nurturing not just her athletic skills but her overall personality as well.',
  },
  {
    id: 4,
    name: 'Apiteh',
    relationship: 'Parent',
    achievement: 'Fastest Boy in Delhi',
    quote: 'Thanks to Go Speed Academy, my son has become the fastest boy in Delhi, winning all the inter-school championships he participated in. The dedication of the coaches has been instrumental in his success.',
  },
  {
    id: 5,
    name: 'Vandana Vasudeva',
    relationship: 'Parent',
    achievement: 'Delhi State Champion (Overcame Injuries)',
    quote: 'My child faced numerous injuries during her childhood, but Go Speed handled them with utmost care and expertise. Their dedication and support brought out the best in her, helping her become the Delhi state champion. I couldn\'t be more grateful!',
  },
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-white to-muted">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-theme-black mb-4">
            What Parents Say
          </h2>
          <p className="text-lg lg:text-xl text-text-secondary max-w-3xl mx-auto">
            Real stories from proud parents whose children have achieved remarkable success at GO Speed Academy
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 lg:p-8 border border-border hover:border-theme-orange transform hover:-translate-y-1"
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <svg
                  className="w-10 h-10 text-theme-orange opacity-50"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>

              {/* Testimonial Content */}
              <p className="text-text-primary text-base lg:text-lg leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </p>

              {/* Achievement Badge */}
              <div className="mb-4 pb-4 border-b border-border">
                <div className="inline-block bg-gradient-to-r from-theme-orange to-theme-red text-white px-4 py-2 rounded-full text-sm font-semibold">
                  🏆 {testimonial.achievement}
                </div>
              </div>

              {/* Parent Info */}
              <div>
                <p className="font-bold text-theme-black text-lg">{testimonial.name}</p>
                <p className="text-text-secondary text-sm">{testimonial.relationship}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Indicator */}
        <div className="mt-12 lg:mt-16 text-center">
          <div className="inline-flex items-center gap-2 bg-theme-orange/10 px-6 py-3 rounded-full">
            <svg
              className="w-5 h-5 text-theme-orange"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            <span className="text-theme-black font-semibold">
              Verified testimonials from real GO Speed families
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}